(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goldline-chauffeur"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    const page=document.querySelector('.gl-page');
    if(!page||page.dataset.initialized)return;
    page.dataset.initialized='true';
    const form=page.querySelector('#GoldlineChauffeurForm');
    function updateOwnerDetails(){
      if(!form)return;
      const target=form.querySelector('#goldline_request_details');
      if(!target)return;
      form.querySelector('#gl-shopify-email').value=form.querySelector('#gl-email').value;
      form.querySelector('#gl-shopify-phone').value=form.querySelector('#gl-phone').value;
      const fields=[['Name','gl-name'],['Phone','gl-phone'],['Email','gl-email'],['Service','gl-service'],['Vehicle','gl-vehicle'],['Date','gl-date'],['Time (Eastern)','gl-time'],['Passengers','gl-passengers'],['Luggage','gl-luggage'],['Flight','gl-flight'],['Hours','gl-hours'],['Reply by','gl-reply'],['Pickup','gl-pickup'],['Destination','gl-dropoff'],['Notes','gl-notes']];
      const details=fields.map(function(field){const input=form.querySelector('#'+field[1]);return field[0]+': '+(input&&input.value.trim()||'Not provided');}).join('\n');
      target.value=details.length>1400?details.slice(0,1320)+'\n[Long request: see the booking email for complete details.]':details;
    }
    if(form){form.addEventListener('input',updateOwnerDetails);form.addEventListener('change',updateOwnerDetails);form.addEventListener('submit',updateOwnerDetails,true);updateOwnerDetails();}
    page.querySelectorAll('[data-gl-vehicle],[data-gl-service]').forEach(function(link){
      link.addEventListener('click',function(){
        const vehicle=page.querySelector('#gl-vehicle');
        const service=page.querySelector('#gl-service');
        if(link.dataset.glVehicle&&vehicle)vehicle.value=link.dataset.glVehicle;
        if(link.dataset.glService&&service)service.value=link.dataset.glService;
        updateOwnerDetails();
      });
    });
    const date=page.querySelector('#gl-date');
    if(date){
      const today=new Date();
      const localDate=[today.getFullYear(),String(today.getMonth()+1).padStart(2,'0'),String(today.getDate()).padStart(2,'0')].join('-');
      date.min=localDate;
      date.addEventListener('change',function(){date.setCustomValidity(date.value&&date.value<localDate?date.dataset.pastDate:'');});
    }
    const success=page.querySelector('.gl-success');
    const errors=page.querySelector('.gl-errors');
    if(success||errors){(success||errors).scrollIntoView({block:'center'});(success||errors).focus({preventScroll:true});}
    if(form)form.addEventListener('submit',function(){
      if(!form.checkValidity())return;
      const button=form.querySelector('button[type="submit"]');
      if(!button)return;
      const label=button.innerHTML;
      button.dataset.originalLabel=label;
      button.setAttribute('aria-busy','true');
      button.disabled=true;
      button.textContent=button.dataset.pending;
      window.setTimeout(function(){button.disabled=false;button.removeAttribute('aria-busy');button.innerHTML=label;},10000);
    });
    window.addEventListener('pageshow',function(){if(form){const button=form.querySelector('button[type="submit"]');if(button&&button.disabled){button.disabled=false;button.removeAttribute('aria-busy');if(button.dataset.originalLabel)button.innerHTML=button.dataset.originalLabel;}}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
